import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import ja from 'date-fns/locale/ja'

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MenuList from "~/components/Blocks/MenuList";
import MemberList from "~/components/Blocks/MemberList";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";

const PartyInputs = (props) => {
    const { party_data, billError, othersError, checkError, organizerBusinessName } = props;

    let enable_date = new Date();
    enable_date.setDate(enable_date.getDate() + 6);

    const [party_date, set_party_date] = React.useState(enable_date);

    useEffect(() => {
        party_data?.set_party_date ? set_party_date(party_data?.set_party_date) : set_party_date(enable_date);
    }, [party_data]);

    const setValue = (val) => {
        if (val < enable_date) {
            alert("6日以降の日付を入力してください。");
            return;
        }
        set_party_date(val);
    };

    const onChange = (params) => {
        const { name, value } = params;
        switch(name)
        {
            case "payment_bill_flag":
                document.getElementsByName("payment_bill_company")[0].disabled = !value;
                break;
            case "payment_others_flag":
                document.getElementsByName("payment_others_detail")[0].disabled = !value;
                break;
            default:
                break;
        }
    };

    return (
        <React.Fragment>
            <Typography variant="h5" gutterBottom component="div">
                開始時間*
            </Typography>
            <TextField
                required
                sx={{ maxWidth: "10rem", mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                name="party_start_time"
                fullWidth
                type="time"
                InputLabelProps={{ shrink: true }}
                defaultValue={party_data?.party_start_time ? party_data?.party_start_time : ""}
            />

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                開催名*
            </Typography>
            <Grid
                container
                direction="column"
                justifyContent="center"
                sx={{ fontSize: "0.7rem" }}
            >
                {"※参加登録フォームに記載されます。参加者様が認識できる開催名をご入力ください。"}
            </Grid>
            <TextField
                required
                sx={{ mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                name="party_name"
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 255 }}
                defaultValue={party_data?.party_name ? party_data?.party_name : ""}
            />

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                懇親会の説明
            </Typography>
            <Grid
                container
                direction="column"
                justifyContent="center"
                sx={{ fontSize: "0.7rem" }}
            >
                {"※参加登録フォームに記載されます。"}
            </Grid>
            <TextField
                minRows={3}
                sx={{ mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                name="description"
                fullWidth
                inputProps={{ maxLength: 255 }}
                defaultValue={party_data?.description ? party_data?.description : ""}
            />

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                参加予定人数*
            </Typography>
            <Stack direction="row" alignItems="flex-end" sx={{ mb: 3 }}>
                <TextField
                    required
                    sx={{ maxWidth: "10rem", fontSize: "1.2rem" }}
                    label={false}
                    variant="outlined"
                    name="planned_number"
                    fullWidth
                    //type="number"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    inputProps={{ maxLength: 3, pattern: "^[1-9?][0-9?]{0,2}$" }}
                    defaultValue={party_data?.planned_number ? party_data?.planned_number : ""}
                />
                <div style={{ fontSize: "1.5rem" }}>人</div>
            </Stack>

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                WFPF承認番号*
            </Typography>
            <TextField
                required
                sx={{ mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                name="wfpf_number"
                InputLabelProps={{ shrink: true }}
                fullWidth
                inputProps={{ maxLength: 20, pattern: "^[0-9]{20}$", title: "半角数字20桁" }}
                defaultValue={party_data?.wfpf_number ? party_data?.wfpf_number : ""}
            />

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                お支払い方法*
            </Typography>
            <a style={{ color: "red" }} >
                {checkError ? "お支払い方法を選択してください" : ""}
            </a>
            <FormGroup sx={{width: "100%"}}>
                <Grid container>
                    <FormControlLabel
                        control={<Checkbox name="payment_bill_flag" defaultChecked={party_data?.payment_bill_flag === "1" ? true : false} />}
                        label="請求書：社名"
                        onChange={(e) => onChange({ name: "payment_bill_flag", value: e.target.checked })}
                    />
                    <TextField
                        sx={{ fontSize: "1.2rem", flex: 0.5 }}
                        label={false}
                        variant="outlined"
                        name="payment_bill_company"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 30}}
                        defaultValue={party_data?.payment_bill_company ? party_data?.payment_bill_company : ""}
                        disabled={party_data?.payment_bill_flag ? false : true}
                        required
                        error={billError}
                        helperText={billError ? "入力してください" : ""}
                    />
                </Grid>
                <Typography gutterBottom sx={{ ml: 12 }}>
                    担当者業務上氏名　{organizerBusinessName}
                </Typography>
                <FormControlLabel
                    control={<Checkbox name="payment_paypay_flag" defaultChecked={party_data?.payment_paypay_flag === "1" ? true : false} />}
                    label="PayPay"
                />
                <Grid container>
                    <FormControlLabel
                        control={<Checkbox name="payment_others_flag" defaultChecked={party_data?.payment_others_flag === "1" ? true : false} />}
                        label="その他："
                        onChange={(e) => onChange({ name: "payment_others_flag", value: e.target.checked })}
                    />
                    <TextField
                        sx={{ fontSize: "1.2rem", flex: 1 }}
                        label={false}
                        variant="outlined"
                        name="payment_others_detail"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 255}}
                        defaultValue={party_data?.payment_others_detail ? party_data?.payment_others_detail : ""}
                        disabled={party_data?.payment_others_flag ? false : true}
                        required
                        error={othersError}
                        helperText={othersError ? "入力してください" : ""}
                    />
                </Grid>
            </FormGroup>
            
            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                クーポンコード
            </Typography>
            <Grid
                container
                direction="column"
                justifyContent="center"
                sx={{ fontSize: "0.7rem" }}
            >
                {"※クーポンコードをお持ちの方はこちらにご入力ください。"}
            </Grid>
            <TextField
                sx={{ mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                // variant="filled"
                name="coupon_code"
                fullWidth
                inputProps={{ maxLength: 31 }}
                defaultValue={party_data?.coupon_code ? party_data?.coupon_code : ""}
            />

            <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                ご質問やお問い合わせ
            </Typography>
            <TextField
                multiline
                minRows={3}
                sx={{ mb: 3, fontSize: "1.2rem" }}
                label={false}
                variant="outlined"
                name="inquiry"
                fullWidth
                inputProps={{ maxLength: 10000 }}
                defaultValue={party_data?.inquiry ? party_data?.inquiry : ""}
            />
        </React.Fragment>
    );
};

export default PartyInputs;
